export const dataCrlPedidosReducer = (state, action) => {
  state.dataCrlPedidos.data = action.payload.items;
  state.dataCrlPedidos.pagination = {
    page: action.meta.arg.pagina,
    rowsPerPage: action.meta.arg.itensPorPagina,
    totalPages: action.payload.totalPaginas,
    totalItems: action.payload.totalRegistros,
  };
  state.dataCrl.configTabs.filtersForDetails = {
    ...action.meta.arg,
    totalPages: action.payload.totalPaginas,
    totalItems: action.payload.totalRegistros,
  };
};
